import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Grid, Paper, Typography, Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import { MoneyTransfer as DMT_TRANSFER } from 'Components/Api/NovityDMTAPI';
import ReactTable from 'Components/ReactTable/ReactTable';
import { useHistory } from 'react-router';
import { LOGOUT } from 'ConstComponents';
const CustomContainer = HOCLoader(Container);

export const TransactionConfirmation = ({ ActiveDMTName }) => {
    const classes = commonStyle();
    const location = useLocation();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [severity, setSeverity] = useState('success');
    const [status, setStatus] = useState('success');
    const Mobile = location?.state?.Mobile; 
    const { MainRequest, OTPListRequest, DMTName } =
        location.state || {};
    const [otpList, setOTPList] = useState([]);
    const [formObject, setFormObject] = useState({
        SenderMobile: Mobile,
        DMTName: ActiveDMTName,
        OTPType: 0,
        PublicIP: ' '
    });

    const {
        AccountNo,
        OriginalAmount,
        BankName,
        BeneMobile,
        BeneficiaryID,
        BeniName,
        IFSC,
        Name,
        PaymentType,
        RechargePin,
        Remark,
        SenderID,
        SenderName,
        Pipe,
        Latitude,
        Longitude
    } = MainRequest; 
    const [mainColumns, setMainColumns] = useState([]);

    useEffect(() => {
        createColumns();
        setOTPList(
            Array.isArray(OTPListRequest) ? OTPListRequest : [OTPListRequest]
        );
    }, [Mobile]);

    const handleBack = () => {
        history.push('/KYCPPI_SenderSearch', {
            Mobile: MainRequest.Mobile,
            DMTName: DMTName
        });
    };
    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'OTPRefid',
            srno: true
        });

        columns.push({
            label: <b>Amount</b>,
            name: 'OriginalAmount'
        });

        columns.push({
            label: (
                <h6>
                    <b>OTP </b>
                </h6>
            ),
            name: 'OTP',
            editableWithNumberOnly: true,
            length: 6
        });
        columns.push({
            label: (
                <h6>
                    <b>Transfer</b>
                </h6>
            ),
            name: 'OTPRefid',
            transfer: true,
            buttonTitle: 'Transfer',
            callback: (value) => {
                TransferWithOTP(value);
            }
        });

        columns.push({
            label: <b>Status</b>,
            name: 'Status',
            customStatus: true
        });

        columns.push({
            label: <b>Message</b>,
            name: 'Message'
        });
        columns.push({
            label: 'BillNumber',
            name: 'BillNumber',
            hide: true
        });
        columns.push({
            label: 'OriginalAmount',
            name: 'OriginalAmount',
            hide: true
        });

        setMainColumns(columns);
    };

    const updateOTPStatus = (otpToken, status, message) => {
        setOTPList((prevList) =>
            prevList.map((item) =>
                item.OTPRefid === otpToken
                    ? {
                          ...item,
                          Status: status,
                          Message: message,
                          OTP: ''
                      }
                    : item
            )
        );
    };
    const TransferWithOTP = async (values) => {
        const otpToken = values[0];
        let jsonObj = {
            Mobile: MainRequest.Mobile,
            BeneMobile: BeneMobile,
            Name: Name,
            SenderName: SenderName,
            BankName: BankName,
            AccountNo: AccountNo,
            IFSC: IFSC,
            BeneficiaryID: BeneficiaryID,
            SenderID: SenderID,
            PaymentType: PaymentType,
            RechargePin: RechargePin,
            Remark: Remark,
            DMTName: DMTName,
            Pipe: Pipe,
            BillNumber: values[6],
            OriginalAmount: values[7],
            OTPRefID: otpToken,
            Amount: values[1],
            OTP: values[2],
            Latitude: Latitude,
            Longitude: Longitude
        };
        setIsError(false);
        setLoading(true);
        var apirequest = JSON.stringify(jsonObj);
        var response = await DMT_TRANSFER(apirequest);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);
            setIsError(true);

            return;
        }

        var data = JSON.parse(response.data);
        setStatus(data.Status);
        if (data.Status === 'FAILURE') {
            setSeverity('error');
            setResponseMessage(data.Message);
            setIsError(true);
            updateOTPStatus(otpToken, 'FAILURE', data.Message);
            return;
        }
        updateOTPStatus(otpToken, data.Status, data.Message);
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Grid
                container
                spacing={2}
                style={{
                    marginBottom: '12px'
                }}
            >
                <Grid item xs={12}>
                    <Paper className={classes.PaperStyle}>
                        <Typography
                            variant="subtitle1"
                            style={{
                                fontWeight: 'bold',
                                marginBottom: '1rem'
                            }}
                        >
                            Sender
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={4}>
                                <Typography
                                    variant="body1"
                                    style={{
                                        marginBottom: '0.5rem'
                                    }}
                                >
                                    Name :{SenderName}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography
                                    variant="body1"
                                    style={{
                                        marginBottom: '0.5rem'
                                    }}
                                >
                                    Mobile : {MainRequest.Mobile}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<ArrowBackIcon />}
                                    onClick={handleBack}
                                >
                                    Back To Beneficiary List
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>

                <Grid item xs={12}>
                    <Paper className={classes.PaperStyle}>
                        <Typography
                            variant="subtitle1"
                            style={{
                                fontWeight: 'bold',
                                marginBottom: '1rem'
                            }}
                        >
                            Bene
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={4}>
                                <Typography
                                    variant="body1"
                                    style={{
                                        marginBottom: '0.5rem'
                                    }}
                                >
                                    Amount : {OriginalAmount}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography
                                    variant="body1"
                                    style={{
                                        marginBottom: '0.5rem'
                                    }}
                                >
                                    Account No : {AccountNo}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography
                                    variant="body1"
                                    style={{
                                        marginBottom: '0.5rem'
                                    }}
                                >
                                    IFSC : {IFSC}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>

            <ReactTable
                data={otpList}
                columns={mainColumns}
                headerToolbar={false}
            />
        </CustomContainer>
    );
};
